import { motion } from 'framer-motion'
import { FileText, History, Search, Sparkles } from 'lucide-react'
import { Button } from './Button'

interface EmptyStateProps {
  type?: 'default' | 'search' | 'history' | 'results'
  title?: string
  description?: string
  actionLabel?: string
  onAction?: () => void
}

const icons = {
  default: FileText,
  search: Search,
  history: History,
  results: Sparkles,
}

const defaultProps = {
  default: {
    title: 'No items yet',
    description: 'Get started by creating your first item.',
  },
  search: {
    title: 'No results found',
    description: 'Try adjusting your search terms or filters.',
  },
  history: {
    title: 'No history yet',
    description: 'Your humanized text transformations will appear here.',
  },
  results: {
    title: 'No results yet',
    description: 'Enter some text and select a style to humanize it.',
  },
}

export const EmptyState = ({
  type = 'default',
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) => {
  const Icon = icons[type]
  const defaultTitle = defaultProps[type].title
  const defaultDescription = defaultProps[type].description
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-col items-center justify-center py-16 px-4 text-center"
    >
      <div className="w-16 h-16 rounded-full bg-dark-bg-secondary flex items-center justify-center mb-4">
        <Icon className="w-8 h-8 text-dark-text-muted" />
      </div>
      <h3 className="text-lg font-semibold text-dark-text-primary mb-2">
        {title ?? defaultTitle}
      </h3>
      <p className="text-sm text-dark-text-secondary max-w-sm mb-6">
        {description ?? defaultDescription}
      </p>
      {actionLabel && onAction && (
        <Button onClick={onAction} variant="primary">
          {actionLabel}
        </Button>
      )}
    </motion.div>
  )
}
